<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import inspeccionesSeguridadAPI from "../../../services/standards/inspeccionesSeguridad/inspeccionesSeguridadAPI";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "4.2.4 Inspecciones de seguridad",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
  },
  data() {
    return {
      title: "4.2.4 Inspecciones de seguridad",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "4.2.4 Inspecciones de seguridad",
        },
        {
          text: "Editar",
          active: true,
        },
      ],
      list: [],
      themes: [],
      search: "",
      tipos: [],
      file: null,
      usersList: [],
      form_submitting: false,
      inspeccion: {
        schedule_date: null,
        other: null,
        silist_id: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,
      company: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading1: true,
      item: null,
      itemData: null,
    };
  },
  validations: {
    inspeccion: {
      employee_id: {
        required,
      },
      schedule_date: {
        required,
      },
      silist_id: {
        required,
      },
    },
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(48)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getShow() {
      inspeccionesSeguridadAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.inspeccion = {
            schedule_date: response.data.schedule_date,
            other: response.data.other,
            silist_id: response.data.silist_id,
            employee_id: response.data.employee_id,
            companies_id: response.data.companies_id,
          };
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    save() {
      this.submitted = true;
      this.loading1 = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        inspeccionesSeguridadAPI
          .update(this.$route.params.id, {
            schedule_date: this.inspeccion.schedule_date,
            other: this.inspeccion.other,
            silist_id: this.inspeccion.silist_id,
            employee_id: this.inspeccion.employee_id,
            companies_id: this.inspeccion.companies_id,
          })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 48,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Informacion actualizada con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  this.$router.go(-1);
                }, 2000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 48)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getInspeccion() {
      inspeccionesSeguridadAPI.get(this.companyID)
        .then((response) => {
          this.list = response.data.data;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    getList() {
      inspeccionesSeguridadAPI
        .getList(this.companyID)
        .then((response) => {
          this.tipos = response.data;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getData();
    this.getItems();
    this.getUsers();
    this.getItemData();
    this.getList();
    this.getShow();
    this.getInspeccion();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-4 px-2" label="Seleccionar inspección a realizar" label-for="inpeccion">
                    <select id="employeeID" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="inspeccion.silist_id" :class="{
                        'is-invalid': $v.inspeccion.silist_id.$error && submitted,
                      }">
                      <b-form-select-option v-for="item in tipos" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.inspeccion.silist_id.$error">
                      <small v-if="!$v.inspeccion.silist_id.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Fecha Programada" label-for="trainingDate">
                    <b-form-input type="date" id="trainingDate" :class="{
                      'is-invalid': $v.inspeccion.schedule_date.$error && submitted,
                    }" v-model="inspeccion.schedule_date" :disabled="!allowAccess() || !getRole('Crear')">
                    </b-form-input>
                    <div v-if="submitted && $v.inspeccion.schedule_date.$error">
                      <small v-if="!$v.inspeccion.schedule_date.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Responsable" label-for="employee">
                    <select id="employeeID" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="inspeccion.employee_id" :class="{
                        'is-invalid': $v.inspeccion.employee_id.$error && submitted,
                      }">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.inspeccion.employee_id.$error">
                      <small v-if="!$v.inspeccion.employee_id.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <div v-if="inspeccion.silist_id === 7" class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Otro ¿Cuál?" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="inspeccion.other" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
